import { Injectable } from '@angular/core';
import { CampaignWithCountDto } from '../../../../common/general-types/campaigns.dto';
import { BriefResponseDto } from '../../../../common/general-types/briefs.dto';

/**
 * Keeps the Promote to Brief drawer's campaign and brief lists between openings, so that
 * reopening the drawer shows them straight away. The drawer still refreshes them in the
 * background each time it opens (stale-while-revalidate), so nothing stays out of date for long.
 */
@Injectable({ providedIn: 'root' })
export class PromoteToBriefCache {
  private readonly campaignsByBrand = new Map<string, CampaignWithCountDto[]>();
  private readonly briefsByCampaign = new Map<string, BriefResponseDto[]>();

  campaigns(brandId: string): CampaignWithCountDto[] | undefined {
    return this.campaignsByBrand.get(brandId);
  }

  setCampaigns(brandId: string, campaigns: CampaignWithCountDto[]): void {
    this.campaignsByBrand.set(brandId, campaigns);
  }

  briefs(campaignId: string): BriefResponseDto[] | undefined {
    return this.briefsByCampaign.get(campaignId);
  }

  setBriefs(campaignId: string, briefs: BriefResponseDto[]): void {
    this.briefsByCampaign.set(campaignId, briefs);
  }
}
